import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaShieldAlt, FaUserLock, FaCookieBite, FaChild, FaGlobe, FaShareAlt, FaUserEdit, FaBalanceScale, FaGlobeAmericas, FaBell } from 'react-icons/fa';

const PrivacyPolicyPage = () => {
  const [expandedSections, setExpandedSections] = useState({
    section1: true,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    section6: false,
    section7: false,
    section8: false,
    section9: false,
    section10: false
  });

  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy | VEDUS Supply Chain Management</title>
        <meta name="description" content="Privacy Policy for VEDUS Supply Chain Management services." />
      </Helmet>

      <div className="container mx-auto px-4 py-12">
        <motion.h1 
          className="text-3xl font-bold mb-2 text-secondary-900 dark:text-white text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Privacy Policy
        </motion.h1>
        
        <motion.p 
          className="text-center mb-8 text-secondary-600 dark:text-secondary-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Last Updated: {new Date().toLocaleDateString()}
        </motion.p>
        
        <motion.div 
          className="max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {/* Quick Navigation */}
          <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-md p-6 mb-6">
            <h2 className="text-xl font-semibold mb-4 text-secondary-900 dark:text-white">Quick Navigation</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <a 
                href="#section1" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section1: true});
                  document.getElementById('section1').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaGlobe className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Introduction</span>
              </a>
              <a 
                href="#section2" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section2: true});
                  document.getElementById('section2').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaUserLock className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Information We Collect</span>
              </a>
              <a 
                href="#section3" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section3: true});
                  document.getElementById('section3').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaShareAlt className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">How We Use Information</span>
              </a>
              <a 
                href="#section4" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section4: true});
                  document.getElementById('section4').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaGlobeAmericas className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Information Sharing</span>
              </a>
              <a 
                href="#section5" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section5: true});
                  document.getElementById('section5').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaShieldAlt className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Data Security</span>
              </a>
              <a 
                href="#section6" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section6: true});
                  document.getElementById('section6').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaUserEdit className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Your Rights</span>
              </a>
              <a 
                href="#section7" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section7: true});
                  document.getElementById('section7').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaCookieBite className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Cookies</span>
              </a>
              <a 
                href="#section8" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section8: true});
                  document.getElementById('section8').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaChild className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Children's Privacy</span>
              </a>
              <a 
                href="#section9" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section9: true});
                  document.getElementById('section9').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaBell className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Changes to Policy</span>
              </a>
              <a 
                href="#section10" 
                className="flex items-center p-3 bg-secondary-50 dark:bg-secondary-700 rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  setExpandedSections({...expandedSections, section10: true});
                  document.getElementById('section10').scrollIntoView({behavior: 'smooth'});
                }}
              >
                <FaBalanceScale className="mr-2 text-primary-600 dark:text-primary-400" />
                <span className="text-secondary-900 dark:text-white">Legal Compliance</span>
              </a>
            </div>
          </div>
          
          {/* Main Content */}
          <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-md overflow-hidden">
            <div className="p-6">
              <p className="text-secondary-600 dark:text-secondary-300 mb-6">
                At VEDUS, we value your privacy and are committed to protecting your personal information. 
                This Privacy Policy explains how we collect, use, and safeguard your data when you use our services.
              </p>
              
              {/* Section 1 */}
              <div id="section1" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section1')}
                >
                  <span>1. Introduction</span>
                  {expandedSections.section1 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section1 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>
                      VEDUS Supply Chain Management Pvt. Ltd. ("VEDUS," "we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services or visit our website.
                    </p>
                  </div>
                )}
              </div>
              
              {/* Section 2 */}
              <div id="section2" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section2')}
                >
                  <span>2. Information We Collect</span>
                  {expandedSections.section2 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section2 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We may collect the following types of information:</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">2.1 Personal Information</h3>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Contact information (name, email address, phone number, address)</li>
                      <li>Billing information (payment details, billing address)</li>
                      <li>Shipping information (origin, destination, contents, value)</li>
                      <li>Account credentials (username, password)</li>
                    </ul>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">2.2 Non-Personal Information</h3>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Device information (IP address, browser type, operating system)</li>
                      <li>Usage data (pages visited, time spent on site, clicks)</li>
                      <li>Location data (when using our tracking services)</li>
                      <li>Cookies and similar technologies</li>
                    </ul>
                  </div>
                )}
              </div>
              
              {/* Section 3 */}
              <div id="section3" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section3')}
                >
                  <span>3. How We Use Your Information</span>
                  {expandedSections.section3 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section3 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We use your information for the following purposes:</p>
                    
                    <ul className="list-disc pl-5 space-y-1 mt-2">
                      <li>To provide and maintain our services</li>
                      <li>To process and complete transactions</li>
                      <li>To send transactional messages and updates about your shipments</li>
                      <li>To respond to your inquiries and provide customer support</li>
                      <li>To improve our services and develop new features</li>
                      <li>To detect, prevent, and address technical issues or fraudulent activities</li>
                      <li>To comply with legal obligations</li>
                    </ul>
                    
                    <p className="mt-3">We process your information based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.</p>
                  </div>
                )}
              </div>
              
              {/* Section 4 */}
              <div id="section4" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section4')}
                >
                  <span>4. Information Sharing and Disclosure</span>
                  {expandedSections.section4 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section4 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We may share your information with:</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">4.1 Service Providers</h3>
                    <p>We may share your information with third-party vendors, service providers, and contractors who perform services on our behalf, such as payment processing, data analysis, email delivery, hosting services, and customer service.</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">4.2 Business Partners</h3>
                    <p>We may share your information with our business partners to offer you certain products, services, or promotions.</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">4.3 Legal Requirements</h3>
                    <p>We may disclose your information where required by law or if we believe that such action is necessary to comply with legal obligations, protect our rights, or the safety of others.</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">4.4 Business Transfers</h3>
                    <p>If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of that transaction.</p>
                  </div>
                )}
              </div>
              
              {/* Section 5 */}
              <div id="section5" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section5')}
                >
                  <span>5. Data Security</span>
                  {expandedSections.section5 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section5 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, accidental loss, alteration, or destruction. These measures include:</p>
                    
                    <ul className="list-disc pl-5 space-y-1 mt-2">
                      <li>Encryption of sensitive data</li>
                      <li>Regular security assessments and audits</li>
                      <li>Access controls and authentication procedures</li>
                      <li>Secure network architecture and firewalls</li>
                      <li>Employee training on data protection</li>
                    </ul>
                    
                    <p className="mt-3">While we strive to protect your personal information, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee absolute security of your data.</p>
                  </div>
                )}
              </div>
              
              {/* Section 6 */}
              <div id="section6" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section6')}
                >
                  <span>6. Your Rights and Choices</span>
                  {expandedSections.section6 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section6 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
                    
                    <ul className="list-disc pl-5 space-y-1 mt-2">
                      <li>The right to access and receive a copy of your personal information</li>
                      <li>The right to rectify or update inaccurate or incomplete information</li>
                      <li>The right to request deletion of your personal information</li>
                      <li>The right to restrict or object to processing of your information</li>
                      <li>The right to data portability</li>
                      <li>The right to withdraw consent at any time (where processing is based on consent)</li>
                    </ul>
                    
                    <p className="mt-3">To exercise these rights, please contact us using the information provided in the "Contact Us" section. We will respond to your request within the timeframe required by applicable law.</p>
                  </div>
                )}
              </div>
              
              {/* Section 7 */}
              <div id="section7" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section7')}
                >
                  <span>7. Cookies and Similar Technologies</span>
                  {expandedSections.section7 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section7 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We use cookies and similar tracking technologies to collect and track information about your browsing activities on our website. Cookies are small text files that are stored on your device when you visit a website.</p>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">7.1 Types of Cookies We Use</h3>
                    <ul className="list-disc pl-5 space-y-1">
                      <li><strong>Essential Cookies:</strong> Necessary for the website to function properly</li>
                      <li><strong>Preference Cookies:</strong> Remember your preferences and settings</li>
                      <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
                      <li><strong>Marketing Cookies:</strong> Track your browsing habits to deliver targeted advertising</li>
                    </ul>
                    
                    <h3 className="font-medium mt-3 mb-2 text-secondary-900 dark:text-white">7.2 Cookie Management</h3>
                    <p>Most web browsers allow you to control cookies through their settings. You can typically delete existing cookies, block certain types of cookies, or set your browser to notify you when cookies are being placed on your device.</p>
                  </div>
                )}
              </div>
              
              {/* Section 8 */}
              <div id="section8" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section8')}
                >
                  <span>8. Children's Privacy</span>
                  {expandedSections.section8 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section8 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If we become aware that we have collected personal information from a child without verification of parental consent, we will take steps to remove that information from our servers.</p>
                    
                    <p className="mt-3">If you believe we might have any information from or about a child, please contact us using the information provided in the "Contact Us" section.</p>
                  </div>
                )}
              </div>
              
              {/* Section 9 */}
              <div id="section9" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section9')}
                >
                  <span>9. Changes to This Privacy Policy</span>
                  {expandedSections.section9 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section9 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this page.</p>
                    
                    <p className="mt-3">We encourage you to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                  </div>
                )}
              </div>
              
              {/* Section 10 */}
              <div id="section10" className="border-b border-secondary-200 dark:border-secondary-700 pb-4 mb-4">
                <button 
                  className="flex justify-between items-center w-full text-left font-semibold text-lg text-secondary-900 dark:text-white"
                  onClick={() => toggleSection('section10')}
                >
                  <span>10. Legal Compliance and International Data Transfers</span>
                  {expandedSections.section10 ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                
                {expandedSections.section10 && (
                  <div className="mt-3 text-secondary-600 dark:text-secondary-300 pl-4">
                    <p>Our services are based in India, but we may transfer, store, and process your information in countries other than your own. Data protection laws may differ from those of your country of residence.</p>
                    
                    <p className="mt-3">By using our services, you consent to the transfer of your information to countries outside your country of residence, including to countries that may have different data protection rules than those of your country.</p>
                    
                    <p className="mt-3">We comply with applicable data protection laws, including:</p>
                    <ul className="list-disc pl-5 space-y-1 mt-2">
                      <li>Information Technology Act, 2000 (India)</li>
                      <li>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 (India)</li>
                      <li>Other applicable international data protection regulations</li>
                    </ul>
                  </div>
                )}
              </div>
              
              <div className="mt-6 text-center">
                <p className="text-secondary-600 dark:text-secondary-300">
                  If you have any questions about our Privacy Policy, please <a href="/contact" className="text-primary-600 dark:text-primary-400 hover:underline">contact us</a>.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;